import { getUseResource } from '../resource';
import { eventResources } from '../builders/eventResources';
import { IPaginatedContent } from '../../models/PaginatedContent';
import { IApiEvent } from '../../models/ApiEvent';
import { IServerSidePaginatedFetcherParams } from '../../contexts/Fetcher';

export const apiEvent = {
  useGetEvents: getUseResource(
    eventResources.getApiEvents,
    (body): IPaginatedContent<IApiEvent> => body,
    (params, { filter, sort, ...pagination }: IServerSidePaginatedFetcherParams) => ({
      ...filter,
      ...sort,
      ...pagination,
    })
  ),
};
